import React from "react";
import {
  ImgDiv,
  MainSection,
  MobileImgDiv,
  TextBoxDiv,
  Title,
} from "./elements";
import { Image } from "react-bootstrap";

import { MainCol, MainContainer, MainRow } from "components/common";
import {
  mintbtnimg,
  mobilesoonimg,
  mobilestakingimg,
  stakingimg,
  textBox2,
} from "assets";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";

const NftStaking = () => {
  return (
    <MainSection>
      <TextBoxDiv>
        <Image className="" src={textBox2} />
        <div>
          <h1 className="inner-text">
            NFT <span>Staking</span>
          </h1>
        </div>
      </TextBoxDiv>
      <MainContainer fluid>
        <Title>
          Unveiling our groundbreaking
          <br /> <span>staking solution.</span>
          <br /> Elevate your gaming experience and reap the rewards!
        </Title>
        <Link to="/staking">
          {/* <Tooltip
          placement="bottom"
          title={
            <span>
              Staking NFT will be available soon, please wait for the
              announcement.
            </span>
          }
          color="#363636"
        > */}
          <div className="register-btn-div">
            <Image src={mintbtnimg} alt="button img" className="btn-img" />

            <h1>Start staking</h1>
          </div>
          {/* </Tooltip> */}
        </Link>
        <MainRow>
          <MainCol lg={12}>
            <ImgDiv>
              <Image
                src={stakingimg}
                draggable={false}
                className="select-none"
              />
            </ImgDiv>
            <MobileImgDiv>
              <Image
                src={mobilestakingimg}
                draggable={false}
                className="select-none"
              />
            </MobileImgDiv>
          </MainCol>
        </MainRow>
      </MainContainer>
    </MainSection>
  );
};

export default NftStaking;
